module.exports = __webpack_public_path__ + "static/media/KohinoorBangla-Semibold.9c81f21d.svg";